import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { ExcelInventoryImport_excel_inventory_import_gridComponent } from './ExcelInventoryImport.excel_inventory_import_grid.component';
import { ExcelInventoryImport_excel_inventory_import_staging_gridComponent } from './ExcelInventoryImport.excel_inventory_import_staging_grid.component';
import { ExcelInventoryImport_import_statuses_dd_singleComponent } from './ExcelInventoryImport.import_statuses_dd_single.component';
import { ExcelInventoryImport_import_statuses_dd_multiComponent } from './ExcelInventoryImport.import_statuses_dd_multi.component';

import { Utilities_ShellService } from './Utilities.shell.service';

@Injectable({ providedIn: 'root' })
export class ExcelInventoryImport_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
    public Utilities: Utilities_ShellService,
  ) {
    super(dialog, toastr);
  }

  public ExcelInventoryImport: ExcelInventoryImport_ShellService = this;

  public openexcel_inventory_import_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Inventory Import',
        referenceName: 'ExcelInventoryImport_excel_inventory_import_grid',
        component: ExcelInventoryImport_excel_inventory_import_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openexcel_inventory_import_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ExcelInventoryImport_excel_inventory_import_gridComponent,
      'Inventory Import',
      mode,
      dialogSize
    )
  }
  public openexcel_inventory_import_staging_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Excel inventory import staging',
        referenceName: 'ExcelInventoryImport_excel_inventory_import_staging_grid',
        component: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openexcel_inventory_import_staging_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
      'Excel inventory import staging',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'ExcelInventoryImport_excel_inventory_import_grid') {
      const title = 'Inventory Import';
      const component = ExcelInventoryImport_excel_inventory_import_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ExcelInventoryImport_excel_inventory_import_staging_grid') {
      const title = 'Excel inventory import staging';
      const component = ExcelInventoryImport_excel_inventory_import_staging_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ExcelInventoryImport_import_statuses_dd_single') {
      const title = 'import_statuses_dd';
      const component = ExcelInventoryImport_import_statuses_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ExcelInventoryImport_import_statuses_dd_multi') {
      const title = 'import_statuses_dd';
      const component = ExcelInventoryImport_import_statuses_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    result = this.Utilities.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
